// eslint-disable-next-line no-undef
class ProductSwatches extends HTMLElement {
  connectedCallback () {
    this.swatchesList = this.querySelector('.dropdown-colors__swatches')
    this.optionContainer = this.querySelector('.js-dropdown-colors')

    this.fetchSwatches()
    this.triggerColor()
  }

  fetchSwatches () {
    const tag = this.getAttribute('sku')
    const url = `${window.location.origin}/search?view=variants-products&q=${window.Shopify.styleString}${tag}`

    window.fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.text()
      })
      .then(data => {
        // eslint-disable-next-line no-undef
        const parser = new DOMParser()
        const html = parser.parseFromString(data, 'text/html')
        const fragment = document.createDocumentFragment()
        html.querySelectorAll('li[data-id]').forEach(item => {
          fragment.appendChild(item)
        })
        this.swatchesList.appendChild(fragment)
        this.validateSwatches()
        this.triggerColor()
      })
      .catch(error => console.error('Error fetching swatches:', error))
  }

  triggerColor () {
    const selectedLink = this.querySelector(
      '.selected .swatches__link:not(.swatches__link--redirect)'
    )
    if (selectedLink) {
      selectedLink.click()
    }
  }

  validateSwatches () {
    const ids = new Set()
    let hasColors = false
    this.swatchesList.querySelectorAll('li').forEach(item => {
      const id = item.getAttribute('data-id')
      if (!item.classList.contains('hidden')) {
        hasColors = true
      }
      if (ids.has(id)) {
        item.remove()
      } else {
        ids.add(id)
      }
    })
    if (!hasColors) {
      this.optionContainer.classList.add('hidden')
    } else {
      this.optionContainer.classList.remove('hidden')
    }
  }
}
window.customElements.define('product-swatches', ProductSwatches)
